var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _g2, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotLifestyle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 532,
    viewBox: "0 0 435 532",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.522 94.6998C314.522 94.6998 292.247 135.687 287.767 156.043C283.287 176.4 293.498 189.188 306.963 186.366C320.428 183.543 358.296 132.265 360.924 126.97C363.552 121.675 364.728 109.286 344.43 94.9745C324.133 80.6627 316.774 90.4787 314.522 94.6998Z",
    fill: "url(#paint0_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M344.38 94.9499C361.449 106.989 363.326 117.654 361.9 123.898C354.391 136.387 320.729 108.488 318.827 94.5253C318.54 92.8608 318.634 91.1531 319.102 89.5299C323.507 86.5576 331.19 85.7084 344.38 94.9499Z",
    fill: "url(#paint1_linear_5336_12284)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M345.006 148.875L342.102 152.547C318.551 149.6 306.438 131.317 301.357 120.801L303.559 116.205C307.264 125.297 318.826 147.002 345.006 148.875ZM349.811 142.656C324.308 140.508 311.643 120.551 306.663 109.911C307.464 108.288 308.24 106.739 308.965 105.315C312.469 114.007 324.658 137.786 352.664 138.86L349.811 142.656Z",
    fill: "#C01446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.697 98.1965C359.969 99.2263 360.312 100.236 360.723 101.219C361.611 102.81 362.853 104.177 364.352 105.215C365.379 105.565 373.037 101.369 377.792 96.8477C382.548 92.3269 384.275 89.0549 384.2 87.6062C383.882 85.9478 383.14 84.3993 382.047 83.1104C381.461 82.3298 380.686 81.711 379.795 81.312C375.527 82.9862 371.625 85.4716 368.307 88.6303C365.153 91.5522 362.271 94.7541 359.697 98.1965Z",
    fill: "url(#paint2_linear_5336_12284)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.307 88.6303C371.625 85.4716 375.527 82.9862 379.795 81.312C380.559 81.6191 381.226 82.1286 381.722 82.7857C378.446 84.5481 375.381 86.6764 372.587 89.1298C368.378 92.9029 364.415 96.9408 360.723 101.219C360.312 100.236 359.969 99.2263 359.697 98.1965C362.271 94.7541 365.153 91.5522 368.307 88.6303Z",
    fill: "url(#paint3_linear_5336_12284)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M330.59 98.3965C330.59 98.3965 330.089 105.315 338.774 111.684C346.432 117.304 352.915 119.028 354.566 118.003C356.218 116.979 371.635 106.189 365.854 95.5241C360.073 84.8589 351.888 82.3612 343.88 85.1586C335.871 87.956 330.039 95.7988 330.59 98.3965Z",
    fill: "url(#paint4_linear_5336_12284)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.318 76.3668C334.164 81.108 336.244 85.5439 339.349 89.23C340.677 90.7645 342.419 91.8846 344.368 92.4561C346.316 93.0276 348.389 93.0262 350.337 92.4521C351.866 93.771 353.744 94.623 355.745 94.9064C357.747 95.1898 359.787 94.8928 361.624 94.0506C365.976 92.0256 369.715 88.8892 372.461 84.9589C375.614 80.8494 377.493 75.9092 377.867 70.747C378.048 68.0501 377.516 65.3532 376.326 62.9253C375.136 60.4974 373.329 58.4232 371.085 56.9097C369.19 55.768 367.055 55.0812 364.849 54.9035C362.642 54.7258 360.425 55.062 358.371 55.8856C356.861 54.2667 354.993 53.0217 352.916 52.2499C350.839 51.4781 348.611 51.2007 346.407 51.4397C343.733 51.8627 341.217 52.9778 339.109 54.6738C337.001 56.3698 335.375 58.5875 334.394 61.1058C332.535 65.9757 332.161 71.2852 333.318 76.3668Z",
    fill: "#E02627"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5336_12284",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 332,
    y: 51,
    width: 46,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.318 76.3668C334.164 81.108 336.244 85.5439 339.349 89.23C340.677 90.7645 342.419 91.8846 344.368 92.4561C346.316 93.0276 348.389 93.0262 350.337 92.4521C351.866 93.771 353.744 94.623 355.745 94.9064C357.747 95.1898 359.787 94.8928 361.624 94.0506C365.976 92.0256 369.715 88.8892 372.461 84.9589C375.614 80.8494 377.493 75.9092 377.867 70.747C378.048 68.0501 377.516 65.3532 376.326 62.9253C375.136 60.4974 373.329 58.4232 371.085 56.9097C369.19 55.768 367.055 55.0812 364.849 54.9035C362.642 54.7258 360.425 55.062 358.371 55.8856C356.861 54.2667 354.993 53.0217 352.916 52.2499C350.839 51.4781 348.611 51.2007 346.407 51.4397C343.733 51.8627 341.217 52.9778 339.109 54.6738C337.001 56.3698 335.375 58.5875 334.394 61.1058C332.535 65.9757 332.161 71.2852 333.318 76.3668Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5336_12284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.647 55.536C365.654 54.0124 382.322 60.0319 369.058 80.0385C366.952 83.1946 364.19 85.8611 360.96 87.8567C357.73 89.8522 354.106 91.1299 350.337 91.6029C340.826 93.3513 334.895 81.8369 334.895 81.8369C333.468 86.5825 338.874 92.577 338.874 92.577L358.171 100.295L373.187 93.7259L385.851 73.0449L386.027 60.1568L379.444 55.2862L362.5 51.9893L359.672 55.536",
    fill: "#C22025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.471 55.6357C363.477 54.3869 370.985 67.5248 359.772 78.3399C349.761 88.031 332.617 83.3353 335.095 66.3758C337.948 46.9437 355.117 53.4877 355.117 53.4877L358.471 55.6357Z",
    fill: "#E52F2F"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M358.296 54.0124C359.047 36.8531 372.512 43.2473 375.19 46.1196C373.789 46.366 372.464 46.9283 371.314 47.7638C370.165 48.5992 369.222 49.6857 368.557 50.9402C365.204 56.0355 358.296 54.0124 358.296 54.0124Z",
    fill: "#76A341"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5336_12284",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 358,
    y: 42,
    width: 18,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M358.296 54.0124C359.047 36.8531 372.512 43.2473 375.19 46.1196C373.789 46.366 372.464 46.9283 371.314 47.7638C370.165 48.5992 369.222 49.6857 368.557 50.9402C365.204 56.0355 358.296 54.0124 358.296 54.0124Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5336_12284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.685 45.4705C366.13 45.9201 365.104 48.9173 362.125 51.6898C361.2 52.6215 359.979 53.2041 358.671 53.3383C359.733 52.7515 360.662 51.9522 361.399 50.9904C362.5 49.4491 363.758 48.0261 365.154 46.7443C365.897 46.0895 366.792 45.63 367.757 45.4076C368.723 45.1852 369.729 45.2068 370.685 45.4705Z",
    fill: "#658D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.19 46.1199C373.83 46.0107 372.47 46.3242 371.296 47.0174C370.122 47.7106 369.192 48.7494 368.633 49.9913C367.606 51.6399 366.09 52.9291 364.297 53.6809C362.504 54.4326 360.52 54.6096 358.622 54.1875C360.249 55.0729 361.981 55.7525 363.777 56.2106C364.553 56.0358 372.837 52.7638 373.188 52.5889C373.538 52.4141 376.792 49.1171 376.792 49.1171L375.19 46.1199Z",
    fill: "#658D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.164 45.2457C360.749 37.4278 358.646 50.5408 358.646 50.5408C359.247 48.9173 356.869 45.1208 360.098 41.2743C363.643 41.2231 367.187 41.3983 370.71 41.7988C371.311 42.1235 375.165 43.0727 375.09 43.5972C374.864 44.1891 374.552 44.7446 374.164 45.2457Z",
    fill: "#658D2F"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M358.071 59.1078C358.193 59.0955 358.311 59.0553 358.415 58.9903C358.519 58.9253 358.607 58.8373 358.671 58.7331C359.45 56.1516 359.385 53.3897 358.485 50.8478C357.585 48.3059 355.897 46.1162 353.666 44.5961C351.764 43.6719 351.413 47.7182 352.114 48.2927C352.277 48.424 352.48 48.4947 352.69 48.4925C357.695 50.8404 357.695 58.4833 357.695 58.4833C357.545 58.9829 358.071 59.1078 358.071 59.1078Z",
    fill: "#842412"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5336_12284",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 351,
    y: 44,
    width: 9,
    height: 16
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M358.071 59.1078C358.193 59.0955 358.311 59.0553 358.415 58.9903C358.519 58.9253 358.607 58.8373 358.671 58.7331C359.45 56.1516 359.385 53.3897 358.485 50.8478C357.585 48.3059 355.897 46.1162 353.666 44.5961C351.764 43.6719 351.413 47.7182 352.114 48.2927C352.277 48.424 352.48 48.4947 352.69 48.4925C357.695 50.8404 357.695 58.4833 357.695 58.4833C357.545 58.9829 358.071 59.1078 358.071 59.1078Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5336_12284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.516 44.5462C353.7 44.7715 353.797 45.0549 353.791 45.3455C355.764 46.9259 357.261 49.0192 358.118 51.3947C358.974 53.7701 359.157 56.3355 358.646 58.8081L360.849 56.3104C360.849 56.3104 362.376 49.0421 362.35 48.8173C362.325 48.5925 356.995 44.4713 356.995 44.4713L354.091 43.7969L353.516 44.4713",
    fill: "#72160E"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M348.109 56.0357C345.74 55.8434 343.389 56.5778 341.552 58.0838C341.474 58.1612 341.37 58.2058 341.26 58.2081C341.15 58.2103 341.044 58.1702 340.963 58.096C340.882 58.0218 340.833 57.9194 340.827 57.81C340.82 57.7007 340.855 57.5929 340.926 57.5093C342.595 55.2473 345.082 53.724 347.859 53.2632C348.051 53.2265 348.249 53.2304 348.44 53.2746C348.631 53.3189 348.81 53.4025 348.966 53.5201C349.122 53.6377 349.252 53.7867 349.347 53.9574C349.443 54.1282 349.501 54.3169 349.518 54.5115C349.536 54.7061 349.512 54.9022 349.449 55.0871C349.386 55.2721 349.285 55.4418 349.153 55.5854C349.02 55.729 348.858 55.8433 348.679 55.9208C348.499 55.9984 348.305 56.0375 348.109 56.0357Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M354.366 46.5693C355.775 47.5928 356.86 48.9968 357.495 50.6156C357.495 50.7405 357.345 50.8404 357.27 50.6156C356.869 49.8975 356.4 49.2199 355.868 48.5925C355.362 47.9726 354.742 47.4554 354.041 47.0689C353.99 47.0548 353.943 47.0295 353.904 46.9948C353.864 46.9601 353.833 46.917 353.813 46.8686C353.792 46.8203 353.783 46.7679 353.785 46.7154C353.788 46.6629 353.802 46.6117 353.827 46.5655C353.852 46.5193 353.887 46.4793 353.93 46.4485C353.973 46.4178 354.022 46.397 354.074 46.3878C354.125 46.3785 354.179 46.3811 354.229 46.3952C354.28 46.4094 354.327 46.4347 354.366 46.4694V46.5693Z",
    fill: "#BA5A52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M366.755 43.0726L367.306 43.1975V43.3723H366.78C366.727 43.3723 366.676 43.3512 366.639 43.3138C366.601 43.2763 366.58 43.2255 366.58 43.1725C366.58 43.1195 366.601 43.0687 366.639 43.0312C366.676 42.9937 366.727 42.9727 366.78 42.9727L366.755 43.0726Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M361.424 45.8198C361.985 45.1346 362.652 44.5442 363.402 44.0714C364.165 43.613 365.019 43.3234 365.904 43.2222C365.904 43.2222 366.029 43.2222 366.054 43.2222C366.08 43.2222 366.054 43.372 366.054 43.372C365.284 43.5995 364.569 43.982 363.952 44.496C363.351 45.0141 362.844 45.6308 362.45 46.3193C362.411 46.3767 362.361 46.4258 362.302 46.4638C362.244 46.5017 362.178 46.5279 362.11 46.5406C362.041 46.5534 361.971 46.5525 361.903 46.5381C361.834 46.5237 361.77 46.4961 361.712 46.4567C361.655 46.4173 361.605 46.3671 361.567 46.3087C361.529 46.2504 361.503 46.1852 361.49 46.1167C361.478 46.0483 361.478 45.9781 361.493 45.91C361.507 45.8419 361.535 45.7773 361.575 45.7199L361.424 45.8198Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M332.817 76.4418C332.817 76.4418 332.817 88.3309 334.644 91.9776C336.471 95.6242 342.503 94.4753 344.806 93.3263C346.503 92.4988 347.844 91.089 348.585 89.355C347.611 82.0352 346.062 74.803 343.955 67.7248C343.079 66.0264 339.6 66.451 338.824 66.6009C338.048 66.7507 333.018 67.1504 332.817 76.4418Z",
    fill: "url(#paint5_linear_5336_12284)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M348.56 89.355C347.819 91.089 346.478 92.4988 344.781 93.3263C345.757 91.453 344.956 88.6057 344.13 85.1089C343.304 81.6121 342.728 71.4714 340.05 67.9996C339.795 67.659 339.472 67.3746 339.102 67.164C338.732 66.9535 338.322 66.8213 337.898 66.7757L338.799 66.6009C339.575 66.451 343.054 66.0264 343.93 67.7248C346.037 74.803 347.585 82.0352 348.56 89.355Z",
    fill: "url(#paint6_linear_5336_12284)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M349.561 92.9765C349.561 92.9765 349.561 96.5732 350.837 97.5723C352.141 98.4679 353.625 99.0683 355.186 99.3314C356.747 99.5946 358.346 99.5142 359.872 99.0959C363.076 97.6972 372.061 88.056 373.062 82.636C374.063 77.216 369.834 72.2955 367.306 71.771C364.778 71.2465 361.474 75.2428 358.221 80.1383C354.466 85.7332 348.885 92.6019 349.561 92.9765Z",
    fill: "url(#paint7_linear_5336_12284)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M361.65 81.6869C359.497 85.2586 353.641 94.1755 351.989 96.3485C351.646 96.7869 351.391 97.2873 351.238 97.8221L350.837 97.5723C349.561 96.5733 349.561 92.9766 349.561 92.9766C348.885 92.6019 354.567 85.7332 358.221 80.1383C361.474 75.1429 364.778 71.2465 367.306 71.771C368.26 72.0495 369.124 72.5751 369.809 73.2946C366.494 75.4476 363.706 78.3155 361.65 81.6869Z",
    fill: "url(#paint8_linear_5336_12284)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M248.123 445.378C246.08 451.602 244.409 457.94 243.117 464.361C242.416 469.856 251.051 481.37 271.148 484.342C291.246 487.315 319.052 482.944 325.083 478.398C327.166 477.03 328.684 474.959 329.36 472.564C330.036 470.169 329.824 467.611 328.763 465.36C327.461 463.636 305.712 447.676 294.149 445.378C282.586 443.08 248.123 445.378 248.123 445.378Z",
    fill: "url(#paint9_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M248.123 445.378C248.123 445.378 245.194 454.37 243.743 460.664C250.39 465.753 258.427 468.714 266.793 469.156C280.133 470.33 295.626 464.86 299.33 458.616C300.365 456.846 300.911 454.833 300.911 452.784C300.911 450.734 300.365 448.721 299.33 446.952C297.661 446.275 295.936 445.749 294.174 445.378C282.486 443.13 248.123 445.378 248.123 445.378Z",
    fill: "url(#paint10_linear_5336_12284)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273.802 464.785C285.758 464.785 295.451 459.474 295.451 452.921C295.451 446.369 285.758 441.057 273.802 441.057C261.845 441.057 252.152 446.369 252.152 452.921C252.152 459.474 261.845 464.785 273.802 464.785Z",
    fill: "url(#paint11_linear_5336_12284)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M325.009 478.323C326.835 477.056 328.23 475.262 329.004 473.181C329.778 471.1 329.895 468.832 329.339 466.683C328.316 468.863 326.804 470.778 324.92 472.281C323.037 473.784 320.832 474.834 318.476 475.35C303.335 479.322 274.953 481.645 260.687 475.35C253.309 472.01 247.446 466.042 244.244 458.616C243.693 460.839 243.242 462.887 243.042 464.36C242.341 469.855 250.976 481.37 271.074 484.342C291.171 487.314 318.977 482.868 325.009 478.323Z",
    fill: "url(#paint12_linear_5336_12284)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M242.216 434.913C242.216 434.913 251.426 378.115 253.854 372.47C256.282 366.825 271.599 364.852 279.382 365.227C287.166 365.601 293.248 369.173 295.45 374.144C297.653 379.114 300.456 437.386 300.306 443.03C300.156 448.675 293.774 452.796 284.488 454.345C269.672 456.843 250.45 453.621 245.345 448.7C240.239 443.78 242.216 434.913 242.216 434.913Z",
    fill: "url(#paint13_linear_5336_12284)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M279.382 365.227C272.45 364.877 259.585 366.426 255.13 370.747C254.93 371.146 252.002 377.391 260.687 380.363C269.371 383.335 295.576 383.235 295.45 374.144C293.248 369.173 287.191 365.626 279.382 365.227Z",
    fill: "url(#paint14_linear_5336_12284)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M274.802 420.351C287.316 419.652 294.825 417.704 299.23 415.78C299.23 414.357 299.054 412.933 298.979 411.484C295.525 413.258 288.468 415.581 274.602 416.48C258.459 417.404 250.175 412.933 246.446 409.861C246.17 411.334 245.92 412.808 245.695 414.232C250.05 417.304 257.683 420.601 270.322 420.601C271.749 420.501 273.251 420.451 274.802 420.351ZM299.83 428.494C296.001 430.242 288.593 432.365 274.627 433.139C255.631 434.164 246.946 428.494 243.743 425.521C243.442 427.245 243.192 428.768 242.967 430.092C247.347 433.339 255.631 437.261 270.147 437.261C271.649 437.261 273.226 437.261 274.852 437.111C283.418 436.978 291.912 435.52 300.03 432.79C300.005 431.441 299.93 430.017 299.855 428.494H299.83Z",
    fill: "#C01446"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M253.954 381.387L260.687 384.459C260.687 384.459 255.681 419.427 254.48 428.943C253.278 438.459 257.583 451.672 257.583 451.672C257.583 451.672 249.499 450.573 245.695 445.328C241.891 440.083 247.747 415.58 249.524 406.614C251.301 397.647 253.954 381.387 253.954 381.387Z",
    fill: "url(#paint15_linear_5336_12284)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M262.389 372.495C262.389 372.495 265.717 355.011 258.309 343.871C250.901 332.732 244.218 328.885 242.792 324.789C241.917 321.821 242.079 318.643 243.253 315.779C244.426 312.915 246.541 310.535 249.249 309.028C256.157 305.207 273.201 312.925 282.111 331.508C290.495 348.992 286.766 366.601 286.766 370.747C286.766 374.893 280.309 378.24 272.425 378.24C264.541 378.24 262.013 375.093 262.389 372.495Z",
    fill: "url(#paint16_linear_5336_12284)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M269.096 286.749C267.67 278.881 252.478 270.264 224.221 270.264C195.965 270.264 180.773 278.881 179.371 286.749C177.969 294.616 186.028 308.104 197.917 323.315C209.805 338.526 224.221 336.578 224.221 336.578C224.221 336.578 238.662 338.501 250.55 323.315C262.439 308.129 270.523 294.616 269.096 286.749Z",
    fill: "url(#paint17_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M224.221 270.264C195.964 270.264 180.772 278.881 179.371 286.749C179.158 288.03 179.158 289.338 179.371 290.62C186.103 297.214 203.798 301.885 224.421 301.885C244.444 301.885 261.638 297.514 268.871 291.294C269.143 289.791 269.143 288.252 268.871 286.749C267.745 278.881 252.478 270.264 224.221 270.264Z",
    fill: "url(#paint18_linear_5336_12284)"
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M248.898 288.547C248.898 293.542 237.861 297.688 224.221 297.688C210.581 297.688 199.568 293.592 199.568 288.547C199.568 283.501 210.606 279.43 224.221 279.43C237.836 279.43 248.898 283.501 248.898 288.547Z",
    fill: "url(#paint19_linear_5336_12284)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M245.67 286.499L242.316 262.92H206.151L202.672 286.948C202.672 291.12 212.283 294.441 224.146 294.441C236.009 294.441 245.645 291.095 245.645 286.948C245.665 286.799 245.674 286.649 245.67 286.499Z",
    fill: "url(#paint20_linear_5336_12284)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.629 247.31C141.629 247.31 157.622 203.425 158.998 182.619C160.375 161.813 148.386 150.698 135.497 155.494C122.608 160.29 92.7993 216.613 90.9973 222.333C89.1953 228.052 89.871 240.391 112.096 251.531C134.321 262.671 140.102 251.781 141.629 247.31Z",
    fill: "url(#paint21_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M112.096 251.431C93.3999 242.039 89.971 231.799 90.4215 225.405C95.9527 211.892 133.42 234.546 137.399 248.034C137.924 249.644 138.086 251.35 137.874 253.029C133.97 256.651 126.487 258.649 112.096 251.431Z",
    fill: "url(#paint22_linear_5336_12284)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.288 224.381L150.764 219.386C144.157 209.744 129.465 193.484 105.714 194.059L103.361 198.13C129.591 196.182 144.257 215.939 149.288 224.381ZM97.3296 209.395C125.086 206.073 140.778 227.853 145.558 235.945C146.059 234.422 146.585 232.773 147.16 230.95C140.628 221.159 125.136 203.325 99.6071 204.974C98.8062 206.522 98.0554 207.946 97.3296 209.27V209.395Z",
    fill: "#C01446"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M125.086 245.986C125.086 245.986 124.56 239.068 115.074 234.072C106.665 229.651 100.058 228.902 98.5309 230.176C97.0042 231.45 83.5142 244.388 90.6972 254.079C97.8802 263.77 106.49 265.019 113.998 261.047C121.507 257.076 126.137 248.484 125.086 245.986Z",
    fill: "url(#paint23_linear_5336_12284)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1517 257.101C52.8893 247.022 57.0524 237.383 62.5155 228.477C63.0266 227.663 63.8065 227.053 64.7204 226.752C65.6344 226.451 66.625 226.478 67.5211 226.828L78.5334 231.524C79.4426 231.916 80.1804 232.621 80.6122 233.51C81.0441 234.4 81.1412 235.415 80.886 236.37C78.1652 246.442 74.0278 256.079 68.5973 264.993C68.0896 265.811 67.3098 266.424 66.3947 266.725C65.4795 267.027 64.4872 266.997 63.5917 266.642L52.5043 261.946C51.5883 261.563 50.8438 260.859 50.4107 259.967C49.9776 259.075 49.8855 258.056 50.1517 257.101Z",
    fill: "#C01446"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8777 254.553C50.6274 255.402 50.3771 256.252 50.1519 257.051C49.884 258.003 49.9725 259.02 50.4009 259.911C50.8292 260.803 51.568 261.509 52.4795 261.896L63.4918 266.592C64.3873 266.948 65.3796 266.977 66.2947 266.676C67.2099 266.374 67.9897 265.761 68.4973 264.944C73.9279 256.03 78.0652 246.393 80.7861 236.32C81.0413 235.365 80.9442 234.35 80.5123 233.461C80.0804 232.571 79.3427 231.866 78.4334 231.474C77.5074 231.075 74.2037 233.348 67.7966 248.284C63.1914 259.374 54.5818 258.525 50.8777 254.553Z",
    fill: "#AE164A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8597 236.095C79.8964 235.838 79.8964 235.578 79.8597 235.321C79.8547 235.135 79.7965 234.955 79.692 234.801C79.5876 234.647 79.4412 234.526 79.2702 234.453C79.0991 234.379 78.9106 234.356 78.7268 234.386C78.543 234.416 78.3717 234.497 78.2329 234.621C78.0327 234.791 77.8633 234.994 77.7324 235.221C72.3481 244.045 68.2524 253.591 65.5688 263.57C65.5428 263.786 65.5428 264.004 65.5688 264.219C65.5613 264.422 65.6159 264.622 65.7253 264.794C65.8347 264.965 65.9938 265.099 66.1813 265.177C66.3689 265.256 66.576 265.276 66.775 265.234C66.9741 265.192 67.1557 265.091 67.2957 264.944C67.4427 264.788 67.5766 264.621 67.6962 264.444C73.0657 255.612 77.1605 246.068 79.8597 236.095Z",
    fill: "#7F133D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M142.78 296.69C148.235 287.782 152.389 278.144 155.119 268.066C155.387 267.114 155.298 266.097 154.87 265.206C154.442 264.314 153.703 263.608 152.792 263.22L141.779 258.525C140.884 258.169 139.891 258.14 138.976 258.441C138.061 258.743 137.281 259.356 136.774 260.173C131.343 269.087 127.206 278.724 124.485 288.797C124.231 289.749 124.329 290.76 124.761 291.645C125.193 292.53 125.93 293.23 126.838 293.618L137.85 298.338C138.737 298.669 139.71 298.686 140.608 298.386C141.505 298.086 142.272 297.487 142.78 296.69Z",
    fill: "#C01446"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.203 259.998C141.117 259.689 140.963 259.403 140.751 259.161C140.54 258.919 140.277 258.728 139.981 258.601C139.686 258.474 139.366 258.415 139.045 258.427C138.723 258.44 138.409 258.524 138.125 258.674C137.486 259.031 136.952 259.548 136.573 260.173C131.142 269.087 127.005 278.724 124.284 288.797C124.103 289.489 124.105 290.216 124.289 290.908C124.474 291.599 124.834 292.232 125.335 292.743C126.053 292.755 126.761 292.579 127.389 292.233C128.017 291.887 128.543 291.382 128.914 290.77C134.351 281.859 138.489 272.221 141.203 262.146C141.391 261.442 141.391 260.702 141.203 259.998Z",
    fill: "#AE164A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M125.085 286.249L124.335 288.747C124.081 289.698 124.179 290.709 124.611 291.595C125.043 292.48 125.78 293.18 126.687 293.567L137.699 298.288C138.596 298.638 139.586 298.665 140.5 298.364C141.414 298.063 142.194 297.453 142.705 296.64C148.181 287.751 152.361 278.13 155.119 268.066C155.387 267.114 155.298 266.097 154.87 265.205C154.442 264.314 153.703 263.608 152.791 263.22C152.591 268.066 149.312 277.557 145.283 285.7C139.902 296.565 128.739 290.195 125.085 286.249Z",
    fill: "#AE164A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M137.599 260.723C137.738 260.501 137.907 260.3 138.1 260.123C138.237 260 138.406 259.919 138.588 259.888C138.77 259.857 138.956 259.878 139.126 259.949C139.297 260.019 139.443 260.136 139.55 260.287C139.656 260.437 139.717 260.614 139.727 260.798C139.764 261.063 139.764 261.332 139.727 261.597C137.043 271.568 132.947 281.105 127.563 289.921C127.459 290.116 127.323 290.293 127.163 290.445C127.023 290.593 126.841 290.694 126.642 290.736C126.443 290.778 126.236 290.758 126.048 290.679C125.861 290.6 125.702 290.467 125.592 290.295C125.483 290.124 125.428 289.924 125.436 289.721C125.422 289.505 125.422 289.288 125.436 289.072C128.13 279.097 132.225 269.553 137.599 260.723Z",
    fill: "#7F133D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.871 270.189C134.843 269.888 134.742 269.599 134.576 269.346C134.41 269.094 134.185 268.886 133.92 268.74C124.384 263.894 115.099 259.598 105.588 255.627C96.0778 251.656 86.6173 247.759 76.506 244.237C76.2261 244.138 75.9253 244.11 75.6319 244.158C75.3386 244.206 75.0623 244.328 74.8291 244.512C73.4645 245.927 72.4453 247.636 71.8508 249.508C70.9779 251.235 70.467 253.122 70.3491 255.053C70.3728 255.358 70.4751 255.651 70.6462 255.905C70.8172 256.159 71.0511 256.364 71.3252 256.501C80.8358 261.347 90.1212 265.643 99.6068 269.614C109.092 273.586 118.553 277.482 128.664 281.004C128.951 281.107 129.26 281.131 129.56 281.074C129.859 281.017 130.138 280.88 130.366 280.679C131.694 279.237 132.708 277.536 133.344 275.684C134.271 273.994 134.794 272.113 134.871 270.189Z",
    fill: "#C01446"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M115.95 260.148C112.521 258.6 109.068 257.076 105.589 255.627L100.583 253.504C97.3294 256.002 94.1008 258.5 90.9473 260.998C89.6208 261.997 88.4445 263.046 87.043 264.07C91.1976 265.968 95.3522 267.816 99.5569 269.565L102.786 270.938C107.266 267.442 111.62 263.87 115.95 260.148Z",
    fill: "#7F133D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M134.872 270.189C134.844 269.888 134.742 269.599 134.577 269.346C134.411 269.094 134.186 268.886 133.92 268.74L133.545 268.565C133.221 269.809 132.785 271.021 132.244 272.187C131.591 274.032 130.579 275.73 129.265 277.182C129.015 277.334 128.731 277.422 128.439 277.439C128.147 277.457 127.855 277.403 127.588 277.282C117.577 273.76 107.967 270.039 98.556 265.893C89.1455 261.746 80.0103 257.75 70.6248 252.979C70.4666 253.6 70.3909 254.238 70.3996 254.878C70.4233 255.183 70.5256 255.476 70.6966 255.73C70.8677 255.984 71.1016 256.189 71.3757 256.326C80.8863 261.172 90.1717 265.468 99.6572 269.439C109.143 273.411 118.603 277.307 128.715 280.829C129.002 280.932 129.311 280.956 129.61 280.899C129.91 280.842 130.188 280.705 130.417 280.504C131.745 279.063 132.759 277.362 133.395 275.509C134.279 273.868 134.783 272.05 134.872 270.189Z",
    fill: "#AE164A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4534 248.034C96.0286 247.064 95.5438 246.122 95.0018 245.212C93.8886 243.758 92.4482 242.585 90.7971 241.79C89.7459 241.59 82.7882 246.785 78.7587 252.055C74.7292 257.326 73.5278 260.722 73.7531 262.046C74.3238 263.634 75.2882 265.052 76.5562 266.167C77.3821 266.867 78.4833 267.641 79.059 267.591C83.0417 265.312 86.5368 262.274 89.3455 258.649C92.0289 255.331 94.4078 251.778 96.4534 248.034Z",
    fill: "url(#paint24_linear_5336_12284)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3704 258.749C86.5617 262.374 83.0666 265.412 79.0839 267.691C78.2826 267.51 77.5467 267.113 76.9565 266.542C79.9376 264.314 82.6503 261.75 85.0406 258.899C88.6674 254.555 92.0114 249.983 95.0517 245.212C95.5937 246.122 96.0785 247.064 96.5034 248.034C94.455 251.814 92.0676 255.4 89.3704 258.749Z",
    fill: "url(#paint25_linear_5336_12284)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 270.564C120.83 270.564 124.685 259.324 124.084 255.253C123.483 251.181 117.452 250.257 114.874 250.757C113.005 250.972 111.279 251.86 110.018 253.254C108.623 260.498 107.787 267.838 107.516 275.209C107.816 277.107 111.245 277.707 112.046 277.907C112.847 278.107 117.577 279.33 120.83 270.564Z",
    fill: "url(#paint26_linear_5336_12284)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M110.069 253.329C111.329 251.935 113.055 251.047 114.924 250.832C113.398 252.305 113.247 255.252 112.897 258.824C112.547 262.396 109.894 272.212 111.32 276.308C111.451 276.714 111.665 277.089 111.95 277.407C112.234 277.726 112.582 277.981 112.972 278.156C112.672 278.176 112.371 278.176 112.071 278.156C111.27 278.156 107.841 277.357 107.541 275.459C107.811 268.028 108.656 260.63 110.069 253.329Z",
    fill: "url(#paint27_linear_5336_12284)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M108.367 252.88C108.367 252.88 107.39 249.408 105.864 248.809C104.37 248.283 102.777 248.096 101.202 248.26C99.6261 248.424 98.1067 248.936 96.7536 249.758C94.0506 251.981 88.0189 263.695 88.5445 269.19C89.0701 274.685 94.4511 278.257 97.0289 278.082C99.6068 277.907 101.684 273.086 103.486 267.566C105.614 261.147 109.117 253.03 108.367 252.88Z",
    fill: "url(#paint28_linear_5336_12284)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8072 266.992C100.908 262.971 104.112 252.78 105.113 250.282C105.316 249.765 105.418 249.214 105.413 248.659L105.889 248.809C107.391 249.408 108.392 252.88 108.392 252.88C109.143 253.03 105.639 261.147 103.536 267.566C101.734 273.161 99.657 277.907 97.0791 278.082C96.0816 278.073 95.1047 277.797 94.251 277.282C96.8419 274.304 98.7395 270.789 99.8072 266.992Z",
    fill: "url(#paint29_linear_5336_12284)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M304.501 178.569C305.475 154.263 293.435 134.047 277.608 133.415C261.781 132.783 248.161 151.975 247.187 176.281C246.213 200.587 258.253 220.803 274.08 221.434C289.907 222.066 303.527 202.875 304.501 178.569Z",
    fill: "url(#paint30_linear_5336_12284)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M174.079 221.976C189.892 221.315 201.884 201.092 200.864 176.808C199.844 152.523 186.199 133.373 170.386 134.034C154.573 134.696 142.581 154.918 143.601 179.203C144.62 203.487 158.266 222.638 174.079 221.976Z",
    fill: "url(#paint31_linear_5336_12284)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 155.919C280.534 139.334 264.416 114.457 224.221 114.457C184.176 114.457 167.908 139.434 159.649 155.919C151.39 172.404 155.92 204.974 174.941 242.589C193.962 280.205 224.221 277.557 224.221 277.557C224.221 277.557 254.48 280.055 273.526 242.589C292.572 205.124 297.102 172.379 288.818 155.919Z",
    fill: "url(#paint32_radial_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M224.221 153.871C247.071 153.871 267.669 150.249 282.261 144.43C272.525 129.818 255.806 114.457 224.221 114.457C192.661 114.457 175.942 129.818 166.206 144.43C180.797 150.249 201.395 153.871 224.221 153.871Z",
    fill: "url(#paint33_linear_5336_12284)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M292.772 172.604C287.466 176.4 277.23 182.894 267.194 184.767L265.692 185.067V194.858C258.749 197.416 251.393 198.678 243.993 198.58H243.617V202.351H244.018C252.359 202.549 260.651 201.018 268.37 197.855L269.421 197.356V188.089C277.797 185.827 285.704 182.097 292.772 177.074C292.772 175.551 292.772 174.052 292.772 172.604ZM204.574 198.555C197.175 198.661 189.819 197.408 182.875 194.858V185.067L181.373 184.767C171.362 182.894 161.1 176.4 155.794 172.604C155.794 174.052 155.794 175.551 155.794 177.074C162.893 182.108 170.835 185.838 179.246 188.089V197.356L180.297 197.855C187.991 201.011 196.257 202.542 204.574 202.351H204.949V198.53L204.574 198.555Z",
    fill: "url(#paint34_radial_5336_12284)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M178.245 210.594C178.209 210.436 178.143 210.287 178.049 210.154C177.956 210.022 177.837 209.91 177.7 209.824C177.562 209.738 177.409 209.68 177.249 209.654C177.089 209.627 176.926 209.633 176.768 209.669C176.608 209.702 176.457 209.766 176.322 209.859C176.188 209.951 176.074 210.07 175.988 210.208C175.901 210.346 175.844 210.5 175.818 210.66C175.793 210.821 175.801 210.985 175.842 211.143C176.954 216.09 178.547 220.917 180.597 225.555C180.694 225.765 180.849 225.943 181.044 226.067C181.24 226.191 181.467 226.256 181.699 226.254C181.892 226.251 182.081 226.2 182.249 226.104C182.537 225.955 182.756 225.699 182.859 225.391C182.962 225.084 182.94 224.748 182.8 224.456C180.841 219.991 179.316 215.349 178.245 210.594ZM191.76 224.381C189.603 219.959 187.924 215.321 186.754 210.544C186.713 210.388 186.642 210.241 186.545 210.113C186.447 209.984 186.325 209.876 186.185 209.795C186.046 209.714 185.892 209.661 185.732 209.639C185.571 209.618 185.409 209.628 185.253 209.669C184.936 209.752 184.664 209.955 184.496 210.235C184.327 210.515 184.275 210.85 184.352 211.168C185.615 216.177 187.419 221.034 189.733 225.655C189.841 225.837 189.995 225.988 190.179 226.093C190.363 226.198 190.571 226.254 190.784 226.254C191.007 226.25 191.225 226.18 191.409 226.054C191.544 225.968 191.659 225.857 191.75 225.726C191.84 225.594 191.903 225.447 191.936 225.291C191.969 225.135 191.97 224.975 191.94 224.818C191.909 224.662 191.848 224.513 191.76 224.381Z",
    fill: "url(#paint35_radial_5336_12284)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    d: "M265.667 224.456C265.527 224.748 265.505 225.084 265.608 225.392C265.711 225.699 265.929 225.955 266.218 226.105C266.386 226.2 266.575 226.251 266.768 226.254C266.999 226.253 267.225 226.187 267.42 226.063C267.615 225.939 267.771 225.763 267.87 225.555C269.92 220.917 271.513 216.09 272.625 211.143C272.661 210.979 272.665 210.81 272.635 210.644C272.606 210.479 272.544 210.321 272.453 210.18C272.362 210.038 272.245 209.916 272.107 209.82C271.969 209.724 271.813 209.656 271.649 209.62C271.484 209.584 271.315 209.58 271.149 209.61C270.983 209.639 270.825 209.701 270.683 209.791C270.542 209.882 270.419 209.999 270.323 210.137C270.226 210.275 270.158 210.43 270.122 210.594C269.071 215.342 267.58 219.983 265.667 224.456ZM257.108 226.055C257.302 226.18 257.527 226.249 257.758 226.254C257.97 226.251 258.178 226.195 258.361 226.09C258.545 225.985 258.699 225.835 258.81 225.655C261.13 221.04 262.926 216.181 264.165 211.168C264.207 211.012 264.217 210.85 264.195 210.69C264.173 210.531 264.12 210.377 264.039 210.238C263.957 210.099 263.849 209.977 263.721 209.879C263.592 209.782 263.446 209.711 263.29 209.67C263.133 209.629 262.971 209.619 262.811 209.64C262.651 209.662 262.497 209.715 262.357 209.796C262.218 209.878 262.096 209.985 261.998 210.114C261.9 210.242 261.829 210.388 261.788 210.544C260.618 215.321 258.94 219.96 256.782 224.381C256.608 224.648 256.544 224.971 256.605 225.284C256.666 225.596 256.846 225.873 257.108 226.055Z",
    fill: "url(#paint36_radial_5336_12284)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250.55 135.063C250.55 140.058 238.762 144.18 224.221 144.18C209.68 144.18 197.917 140.108 197.917 135.063C197.917 130.018 209.705 125.946 224.221 125.946C238.737 125.946 250.55 129.918 250.55 135.063Z",
    fill: "url(#paint37_linear_5336_12284)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M247.097 133.015L243.518 109.437H204.95L201.295 133.464C201.295 137.611 211.582 140.958 224.221 140.958C236.86 140.958 247.147 137.586 247.147 133.464C247.142 133.313 247.126 133.163 247.097 133.015Z",
    fill: "url(#paint38_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M252.426 202.72C256.122 187.164 246.482 171.563 230.894 167.874C215.306 164.185 199.673 173.806 195.977 189.362C192.28 204.918 201.92 220.52 217.508 224.209C233.096 227.897 248.73 218.277 252.426 202.72Z",
    fill: "url(#paint39_linear_5336_12284)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M224.221 222.333C240.242 222.333 253.229 209.372 253.229 193.384C253.229 177.397 240.242 164.436 224.221 164.436C208.201 164.436 195.214 177.397 195.214 193.384C195.214 209.372 208.201 222.333 224.221 222.333Z",
    fill: "url(#paint40_linear_5336_12284)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M224.221 215.539C236.482 215.539 246.421 205.62 246.421 193.384C246.421 181.148 236.482 171.229 224.221 171.229C211.961 171.229 202.021 181.148 202.021 193.384C202.021 205.62 211.961 215.539 224.221 215.539Z",
    fill: "#ECAA18"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M231.054 208.745C227.078 208.749 223.174 207.685 219.751 205.666C216.329 203.647 213.513 200.746 211.599 197.268C209.685 193.79 208.743 189.863 208.872 185.897C209.001 181.931 210.197 178.073 212.333 174.727C209.529 176.505 207.162 178.889 205.406 181.702C203.649 184.516 202.549 187.687 202.185 190.982C201.822 194.277 202.205 197.612 203.306 200.739C204.407 203.867 206.198 206.707 208.547 209.051C210.896 211.395 213.742 213.183 216.876 214.282C220.01 215.381 223.351 215.763 226.653 215.4C229.955 215.038 233.133 213.939 235.952 212.186C238.771 210.434 241.16 208.071 242.942 205.274C239.391 207.537 235.267 208.741 231.054 208.745Z",
    fill: "#CAC8C8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M239.138 188.289C237.611 191.161 232.455 191.436 227.65 188.889C222.845 186.341 220.142 181.92 221.693 179.048C223.245 176.175 228.376 175.9 233.206 178.448C238.037 180.996 240.665 185.392 239.138 188.289Z",
    fill: "url(#paint41_linear_5336_12284)"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M274.302 78.3648C274.302 88.0559 281.385 95.8488 290.144 95.8488C298.904 95.8488 305.962 87.981 305.962 78.3648C305.962 68.7486 298.879 60.8809 290.144 60.8809C281.41 60.8809 274.302 68.6737 274.302 78.3648Z",
    fill: "url(#paint42_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M289.043 88.5304C297.528 88.5304 304.41 81.0373 304.836 71.8457C305.584 73.9379 305.965 76.1432 305.962 78.3647C305.962 88.0558 298.879 95.8487 290.144 95.8487C281.41 95.8487 274.302 87.9809 274.302 78.3647C274.302 78.09 274.302 77.7902 274.302 77.5155C275.312 80.6497 277.273 83.3931 279.914 85.3664C282.555 87.3397 285.745 88.4453 289.043 88.5304Z",
    fill: "url(#paint43_linear_5336_12284)"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M296.302 62.2049C298.473 72.0094 299.738 81.9922 300.081 92.0275C299.364 92.6669 298.594 93.2435 297.778 93.751C297.53 82.8171 296.163 71.9372 293.699 61.2808C294.596 61.4986 295.468 61.8083 296.302 62.2049Z",
    fill: "#ECAA18"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M299.605 84.0347C299.856 87.1068 300.006 89.8294 300.081 92.0273C299.364 92.6667 298.594 93.2433 297.778 93.7507C297.778 91.6777 297.628 89.0051 297.403 85.858C298.198 85.3269 298.935 84.716 299.605 84.0347Z",
    fill: "url(#paint44_linear_5336_12284)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M174.14 78.3648C174.14 88.0559 167.057 95.8488 158.323 95.8488C149.588 95.8488 142.605 88.0559 142.605 78.3648C142.605 68.6737 149.713 60.8809 158.448 60.8809C167.182 60.8809 174.14 68.6737 174.14 78.3648Z",
    fill: "url(#paint45_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M159.424 88.5304C150.939 88.5304 144.032 81.0373 143.631 71.8457C142.917 73.944 142.57 76.1491 142.605 78.3647C142.605 88.0558 149.713 95.8487 158.448 95.8487C167.182 95.8487 174.265 87.9809 174.265 78.3647C174.265 78.09 174.265 77.7902 174.265 77.5155C173.249 80.6655 171.273 83.4202 168.612 85.3949C165.951 87.3697 162.739 88.4658 159.424 88.5304Z",
    fill: "url(#paint46_linear_5336_12284)"
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M152.165 62.2049C149.981 72.0072 148.716 81.9912 148.386 92.0275C149.098 92.6726 149.869 93.2496 150.689 93.751C150.924 82.8162 152.291 71.935 154.768 61.2808C153.871 61.4986 152.999 61.8083 152.165 62.2049Z",
    fill: "#ECAA18"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45,
    d: "M148.862 84.0347C148.586 87.1068 148.461 89.8294 148.386 92.0273C149.098 92.6724 149.869 93.2494 150.689 93.7507C150.689 91.6777 150.689 89.0051 151.039 85.858C150.257 85.3203 149.528 84.7098 148.862 84.0347Z",
    fill: "url(#paint47_linear_5336_12284)"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M294.649 101.719L290.094 55.8356C289.682 51.49 287.656 47.4554 284.414 44.5251C281.172 41.5948 276.949 39.9807 272.575 40.0002H175.867C171.493 39.9807 167.27 41.5948 164.028 44.5251C160.786 47.4554 158.76 51.49 158.347 55.8356L153.817 101.719C153.551 104.393 153.85 107.093 154.694 109.645C155.538 112.197 156.909 114.544 158.717 116.535C160.526 118.525 162.733 120.116 165.195 121.204C167.657 122.291 170.321 122.852 173.014 122.849H275.453C278.145 122.848 280.806 122.285 283.267 121.196C285.727 120.107 287.932 118.516 289.74 116.526C291.548 114.536 292.919 112.191 293.764 109.641C294.61 107.09 294.911 104.392 294.649 101.719Z",
    fill: "url(#paint48_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M173.014 118.179C170.975 118.178 168.958 117.751 167.094 116.926C165.23 116.101 163.559 114.896 162.189 113.388C160.82 111.88 159.782 110.103 159.142 108.171C158.501 106.238 158.274 104.194 158.473 102.168L163.003 56.2854C163.309 53.0968 164.798 50.1376 167.178 47.9887C169.558 45.8398 172.657 44.6564 175.867 44.671H272.6C275.806 44.6678 278.899 45.855 281.277 48.0017C283.655 50.1484 285.147 53.1011 285.464 56.2854L289.994 102.168C290.19 104.193 289.959 106.236 289.317 108.167C288.676 110.097 287.637 111.873 286.269 113.38C284.9 114.887 283.231 116.092 281.368 116.918C279.506 117.745 277.491 118.174 275.453 118.179H173.014Z",
    fill: "url(#paint49_linear_5336_12284)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 40H175.867C174.388 39.9999 172.916 40.1931 171.487 40.5745L179.772 95.2493C180.376 99.2232 182.387 102.849 185.441 105.47C188.494 108.091 192.388 109.534 196.415 109.536H252.052C256.078 109.538 259.971 108.097 263.022 105.474C266.072 102.852 268.077 99.2232 268.671 95.2493L276.98 40.5745C275.551 40.1931 274.079 39.9999 272.6 40Z",
    fill: "url(#paint50_linear_5336_12284)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M200.345 445.378C202.387 451.602 204.059 457.94 205.35 464.361C206.051 469.856 197.391 481.37 177.319 484.342C157.246 487.315 129.415 482.944 123.359 478.398C121.285 477.023 119.775 474.95 119.104 472.556C118.433 470.163 118.646 467.609 119.705 465.36C121.006 463.636 142.755 447.676 154.318 445.378C165.881 443.08 200.345 445.378 200.345 445.378Z",
    fill: "url(#paint51_linear_5336_12284)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M200.344 445.378C200.344 445.378 203.273 454.37 204.724 460.664C198.074 465.749 190.039 468.71 181.674 469.156C168.334 470.33 152.841 464.86 149.137 458.616C148.101 456.846 147.556 454.833 147.556 452.784C147.556 450.734 148.101 448.721 149.137 446.952C150.806 446.275 152.531 445.749 154.293 445.378C165.956 443.13 200.344 445.378 200.344 445.378Z",
    fill: "url(#paint52_linear_5336_12284)"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M174.666 464.785C186.622 464.785 196.315 459.474 196.315 452.921C196.315 446.369 186.622 441.057 174.666 441.057C162.709 441.057 153.017 446.369 153.017 452.921C153.017 459.474 162.709 464.785 174.666 464.785Z",
    fill: "url(#paint53_linear_5336_12284)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M123.433 478.323C121.608 477.055 120.217 475.26 119.447 473.178C118.678 471.097 118.566 468.83 119.129 466.683C120.161 468.874 121.689 470.797 123.59 472.301C125.492 473.804 127.717 474.848 130.091 475.35C145.233 479.322 173.614 481.645 187.88 475.35C195.258 472.01 201.121 466.042 204.324 458.616C204.874 460.839 205.325 462.887 205.525 464.36C206.226 469.855 197.566 481.37 177.494 484.342C157.421 487.314 129.49 482.868 123.433 478.323Z",
    fill: "url(#paint54_linear_5336_12284)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M206.251 434.913C206.251 434.913 197.041 378.115 194.613 372.47C192.185 366.825 176.868 364.852 169.059 365.227C161.251 365.601 155.194 369.173 153.016 374.144C150.839 379.114 148.011 437.386 148.161 443.03C148.311 448.675 154.693 452.796 163.954 454.345C178.795 456.843 198.017 453.621 203.122 448.7C208.228 443.78 206.251 434.913 206.251 434.913Z",
    fill: "url(#paint55_linear_5336_12284)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M169.059 365.227C176.017 364.877 188.882 366.426 193.337 370.747C193.537 371.146 196.465 377.391 187.78 380.363C179.096 383.335 152.891 383.235 153.017 374.144C155.119 369.173 161.276 365.626 169.059 365.227Z",
    fill: "url(#paint56_linear_5336_12284)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M178.12 420.501C190.784 420.501 198.417 417.204 202.772 414.132C202.522 412.708 202.272 411.234 202.021 409.761C198.292 412.833 190.008 417.254 173.865 416.38C159.975 415.58 152.942 413.258 149.488 411.384C149.488 412.833 149.313 414.257 149.238 415.68C153.642 417.604 161.101 419.552 173.665 420.251C175.141 420.451 176.718 420.501 178.12 420.501ZM148.412 432.79C156.528 435.531 165.022 436.997 173.59 437.136C175.217 437.136 176.793 437.285 178.295 437.285C192.811 437.285 201.095 433.364 205.45 430.117C205.25 428.793 204.975 427.27 204.699 425.546C201.471 428.519 192.786 434.188 173.79 433.164C159.824 432.39 152.416 430.267 148.587 428.519C148.537 430.017 148.462 431.441 148.412 432.79Z",
    fill: "#C01446"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M194.513 381.387L187.78 384.459C187.78 384.459 192.786 419.427 193.962 428.943C195.138 438.459 190.859 451.672 190.859 451.672C190.859 451.672 198.968 450.573 202.772 445.328C206.576 440.083 200.695 415.58 198.943 406.614C197.191 397.647 194.513 381.387 194.513 381.387Z",
    fill: "url(#paint57_linear_5336_12284)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M186.078 372.495C186.078 372.495 182.725 355.011 190.133 343.871C197.541 332.732 204.249 328.885 205.675 324.789C206.545 321.82 206.381 318.645 205.208 315.782C204.035 312.919 201.923 310.538 199.218 309.028C192.285 305.207 175.241 312.925 166.331 331.508C157.972 348.992 161.701 366.601 161.701 370.747C161.701 374.893 168.158 378.24 176.042 378.24C183.926 378.24 186.454 375.093 186.078 372.495Z",
    fill: "url(#paint58_linear_5336_12284)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M210.08 55.8857H204.85V90.8536H210.08V55.8857Z",
    fill: "#C01446"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M213.334 79.4888V90.8284H235.258V79.4888H230.028V85.6082H218.59V79.4888H213.334Z",
    fill: "#C01446"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M226.899 66.6255H221.668V80.0632H226.899V66.6255Z",
    fill: "#ECAA18"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M213.334 67.2253V55.8857H235.258V67.2253H230.028V61.1059H218.59V67.2253H213.334Z",
    fill: "#C01446"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M243.693 55.8857H238.462V90.8536H243.693V55.8857Z",
    fill: "#C01446"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M224.546 503C296.23 503 354.341 489.078 354.341 471.904C354.341 454.729 296.23 440.807 224.546 440.807C152.863 440.807 94.7515 454.729 94.7515 471.904C94.7515 489.078 152.863 503 224.546 503Z",
    fill: "#C8CBCE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M302.784 254.404C302.784 254.404 294.349 274.185 234.332 279.98C174.315 285.775 152.316 261.972 152.316 261.972C152.316 261.972 152.316 260.498 152.516 257.85C153.517 238.843 158.047 220.56 159.073 204.924C159.121 204.062 159.213 203.204 159.349 202.351C180.122 178.398 174.366 134.389 174.366 134.389C174.366 134.389 173.865 134.389 177.369 131.391C179.262 129.609 181.259 127.941 183.351 126.396C184.076 125.847 186.179 124.273 188.356 122.949H192.461C191.81 138.76 172.639 225.605 224.371 225.105C276.68 225.605 255.206 141.282 253.454 122.949H260.061C265.312 126.189 270.175 130.019 274.552 134.364C268.871 167.883 290.245 198.28 290.245 198.28V199.054L302.759 252.755L302.784 254.404Z",
    fill: "url(#paint59_linear_5336_12284)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M263.164 202.926C261.688 211.143 254.955 230.8 225.047 231.424C195.138 232.049 187.179 212.991 185.277 205.174L191.234 204.574C192.36 210.119 198.017 227.903 224.922 227.328C251.401 226.779 256.307 208.845 257.183 202.826L263.164 202.926Z",
    fill: "#333E7C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M291.171 203.251C277.756 193.984 265.717 169.881 269.096 129.468C270.954 130.966 272.725 132.567 274.402 134.264C269.096 166.734 290.094 198.18 290.094 198.18L291.171 203.251Z",
    fill: "#333E7C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M158.998 206.747C158.998 204.999 159.298 202.226 159.348 202.126C177.093 180.646 175.466 145.329 173.94 134.688C174.979 133.14 176.335 131.829 177.919 130.842C186.329 176.725 173.664 199.454 158.998 206.747Z",
    fill: "#333E7C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M303.585 254.803C303.585 254.803 291.271 276.058 232.305 282.278C173.339 288.497 152.216 262.146 152.216 262.146C152.216 262.146 152.216 259.798 152.691 256.876C192.511 290.52 268.421 277.807 301.708 248.084L303.585 254.803Z",
    fill: "#333E7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5336_12284",
    x1: 316.614,
    y1: 192.838,
    x2: 339.573,
    y2: 40.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5336_12284",
    x1: 327.543,
    y1: 136.49,
    x2: 345.596,
    y2: 83.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5336_12284",
    x1: 361.35,
    y1: 109.198,
    x2: 374.198,
    y2: 81.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5336_12284",
    x1: 366.174,
    y1: 91.953,
    x2: 377.877,
    y2: 71.8615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5336_12284",
    x1: 341.442,
    y1: 112.904,
    x2: 353.019,
    y2: 79.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5336_12284",
    x1: 349.953,
    y1: 95.5305,
    x2: 340.49,
    y2: 62.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5336_12284",
    x1: 361.187,
    y1: 105.934,
    x2: 349.096,
    y2: 78.8453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5336_12284",
    x1: 350.807,
    y1: 103.711,
    x2: 364.738,
    y2: 73.1955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5336_12284",
    x1: 356.956,
    y1: 82.0251,
    x2: 371.242,
    y2: 47.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5336_12284",
    x1: 242.992,
    y1: 464.785,
    x2: 329.714,
    y2: 464.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5336_12284",
    x1: 290.92,
    y1: 428.518,
    x2: 261.565,
    y2: 468.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5336_12284",
    x1: 273.852,
    y1: 440.633,
    x2: 273.752,
    y2: 466.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5336_12284",
    x1: 310.092,
    y1: 466.808,
    x2: 202.854,
    y2: 480.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5336_12284",
    x1: 241.841,
    y1: 410.211,
    x2: 300.331,
    y2: 410.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5336_12284",
    x1: 273.025,
    y1: 388.98,
    x2: 266.046,
    y2: 443.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5336_12284",
    x1: 257.258,
    y1: 388.48,
    x2: 246.339,
    y2: 485.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5336_12284",
    x1: 265.042,
    y1: 306.88,
    x2: 264.717,
    y2: 383.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5336_12284",
    x1: 179.196,
    y1: 303.458,
    x2: 269.271,
    y2: 303.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5336_12284",
    x1: 225.247,
    y1: 323.44,
    x2: 223.876,
    y2: 276.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5336_12284",
    x1: 224.221,
    y1: 283.352,
    x2: 224.221,
    y2: 322.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5336_12284",
    x1: 224.221,
    y1: 257.55,
    x2: 224.221,
    y2: 297.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5336_12284",
    x1: 124.76,
    y1: 152.122,
    x2: 124.76,
    y2: 305.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5336_12284",
    x1: 118.102,
    y1: 207.287,
    x2: 107.984,
    y2: 262.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5336_12284",
    x1: 107.771,
    y1: 232.692,
    x2: 101.163,
    y2: 267.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5336_12284",
    x1: 88.5779,
    y1: 236.775,
    x2: 79.9469,
    y2: 266.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5336_12284",
    x1: 86.3162,
    y1: 254.574,
    x2: 77.6692,
    y2: 276.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5336_12284",
    x1: 118.3,
    y1: 253.023,
    x2: 117.053,
    y2: 287.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5336_12284",
    x1: 110.877,
    y1: 239.572,
    x2: 113.88,
    y2: 269.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5336_12284",
    x1: 103.631,
    y1: 238.797,
    x2: 98.5578,
    y2: 272.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5336_12284",
    x1: 103.675,
    y1: 261.46,
    x2: 99.4054,
    y2: 298.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5336_12284",
    x1: 275.288,
    y1: 126.093,
    x2: 277.335,
    y2: 231.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5336_12284",
    x1: 173.264,
    y1: 124.752,
    x2: 171.22,
    y2: 229.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_5336_12284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.487 137.772) rotate(-1.71487) scale(110.848 81.8541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5336_12284",
    x1: 224.221,
    y1: 172.878,
    x2: 224.221,
    y2: 114.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_5336_12284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.186 185.151) rotate(-1.71487) scale(32.1753 23.7593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_5336_12284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.439 205.049) scale(36.3155 36.2417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_5336_12284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(253.003 205.049) rotate(180) scale(36.3155 36.2417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5336_12284",
    x1: 224.221,
    y1: 129.868,
    x2: 224.221,
    y2: 168.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5336_12284",
    x1: 224.221,
    y1: 104.041,
    x2: 224.221,
    y2: 143.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5336_12284",
    x1: 224.185,
    y1: 185.36,
    x2: 224.185,
    y2: 229.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5336_12284",
    x1: 224.421,
    y1: 166.784,
    x2: 223.973,
    y2: 229.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5336_12284",
    x1: 233.851,
    y1: 178.138,
    x2: 225.63,
    y2: 191.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5336_12284",
    x1: 290.069,
    y1: 60.2065,
    x2: 290.219,
    y2: 98.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5336_12284",
    x1: 290.119,
    y1: 71.496,
    x2: 290.219,
    y2: 97.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5336_12284",
    x1: 298.329,
    y1: 84.5342,
    x2: 299.476,
    y2: 97.8224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F197B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5336_12284",
    x1: 158.398,
    y1: 60.2065,
    x2: 158.248,
    y2: 98.3964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5336_12284",
    x1: 158.347,
    y1: 71.496,
    x2: 158.248,
    y2: 97.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5336_12284",
    x1: 150.138,
    y1: 84.5342,
    x2: 148.992,
    y2: 97.8224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F197B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5336_12284",
    x1: 153.717,
    y1: 81.4122,
    x2: 294.725,
    y2: 81.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5336_12284",
    x1: 224.221,
    y1: 40.1002,
    x2: 224.221,
    y2: 118.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5336_12284",
    x1: 224.221,
    y1: 110.71,
    x2: 224.221,
    y2: 33.0064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5336_12284",
    x1: 205.45,
    y1: 464.785,
    x2: 118.754,
    y2: 464.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5336_12284",
    x1: 157.522,
    y1: 428.518,
    x2: 186.877,
    y2: 468.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5336_12284",
    x1: 174.591,
    y1: 440.633,
    x2: 174.69,
    y2: 466.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5336_12284",
    x1: 138.375,
    y1: 466.808,
    x2: 245.588,
    y2: 480.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5336_12284",
    x1: 206.626,
    y1: 410.211,
    x2: 148.136,
    y2: 410.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5336_12284",
    x1: 175.417,
    y1: 388.98,
    x2: 182.421,
    y2: 443.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5336_12284",
    x1: 191.184,
    y1: 388.48,
    x2: 202.127,
    y2: 485.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE7F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5336_12284",
    x1: 183.425,
    y1: 306.88,
    x2: 183.725,
    y2: 383.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5336_12284",
    x1: 227.6,
    y1: 271.912,
    x2: 227.6,
    y2: 121.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0B18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotLifestyle);
export default __webpack_public_path__ + "static/media/bot-lifestyle.ce6d9f0be53270317f4250c38d9ff078.svg";
export { ForwardRef as ReactComponent };